import { unwrapFieldValue } from 'features/libra/ontology/ontologyFieldDefaults'
import type { FieldValues } from 'features/libra/ontology/ontologyFieldTypes'
import type {
  NiiReportConfig,
  NiiReportFields,
} from 'features/libra/stepComponents/niiReport/niiReportApi'
import {
  ELIGIBILITY_STATUS,
  type EligibilityStatus,
} from 'features/libra/types/eligibility'

/**
 * Pre-screening decides the final result when it screens the asset out, so
 * screening's own override justification would misattribute it and is dropped.
 */
export function resolveCloseoutAttribution(
  fieldValues: FieldValues,
  fields: Pick<NiiReportFields, 'eligibility' | 'justification'>,
  preScreening: NiiReportConfig['preScreening']
): { screenedOutAtPreScreening: boolean; justification?: string } {
  const eligibility = unwrapFieldValue<EligibilityStatus>(
    fieldValues[fields.eligibility]
  )
  const screenedOutAtPreScreening =
    eligibility === ELIGIBILITY_STATUS.NOT_ELIGIBLE &&
    preScreening !== undefined &&
    unwrapFieldValue(fieldValues[preScreening.resultField]) === false
  if (screenedOutAtPreScreening) return { screenedOutAtPreScreening }

  const raw = unwrapFieldValue(fieldValues[fields.justification])
  const justification = typeof raw === 'string' ? raw.trim() : undefined
  return {
    screenedOutAtPreScreening,
    justification: justification || undefined,
  }
}
